import React from "react"
import Typography from "../../atoms/Typography"
import { CustomCol, CustomRow } from "../../spacings"
import classes from "./FaqContacts.module.css"
import { AiOutlineMail } from "react-icons/ai"
import CustomButton from "../../atoms/Button"

interface Props {
  className?: string
}

const FaqContacts = ({ className }: Props) => {
  return (
    <div className={`${className ?? ""} ${classes.root}`}>
      <Typography variant="h5">
        Non trovi la risposta che stai cercando? Contattaci direttamente
      </Typography>
      <Typography variant="subtitle2" weight="light" className="mt-2 mb-6">
        Potremmo avere bisogno di uno o due giorni per risponderti.
      </Typography>
      <CustomRow className="mt-12">
        <CustomCol xs={12} sm={4}>
          <AiOutlineMail className="text-h4" />
          <Typography variant="subtitle1">Scrivici</Typography>

          <a href="mailto:help@vallesi.eu" target="blank">
            <CustomButton variant="outlined">Scrivici</CustomButton>
          </a>
        </CustomCol>
      </CustomRow>
    </div>
  )
}

export default FaqContacts
